import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { EnetassessComponent } from './enetassess/enetassess.component';
import { LoadexamComponent } from './loadexam/loadexam.component';
import { QuestionsComponent } from './questions/questions.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { MediaComponent } from './media/media.component';
import { ResumeexamComponent } from './resumeexam/resumeexam.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { SyncComponent } from './sync/sync.component';
import { MediaHolderComponent } from './questions/media-holder/media-holder.component';
import { AnswerAreaComponent } from './questions/answer-area/answer-area.component';
import { QuestionAreaComponent } from './questions/question-area/question-area.component';
import { QuestionMenuComponent } from './questions/question-menu/question-menu.component';
import { QuestionButtonsComponent } from './questions/question-buttons/question-buttons.component';
import { FinishAssessmentComponent } from './questions/finish-assessment/finish-assessment.component';
import { TimeWarningComponent } from './questions/time-warning/time-warning.component';
import { KillsheetPopupComponent } from './questions/killsheet-popup/killsheet-popup.component';
import { ProgrammeInformationComponent } from './questions/programme-information/programme-information.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ResizableModule } from 'angular-resizable-element';
import { EscapeHtmlPipe } from './keep-html-pipe';
import { ImageViewerModule } from 'ng2-image-viewer';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorModule, DeviceDetectorService } from 'ngx-device-detector';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EnetassessComponent,
    LoadexamComponent,
    QuestionsComponent,
    FeedbackComponent,
    MediaComponent,
    ResumeexamComponent,
    SyncComponent,
    MediaHolderComponent,
    AnswerAreaComponent,
    QuestionAreaComponent,
    QuestionMenuComponent,
    QuestionButtonsComponent,
    FinishAssessmentComponent,
    TimeWarningComponent,
    KillsheetPopupComponent,
    ProgrammeInformationComponent,
    EscapeHtmlPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxImageZoomModule.forRoot(),
    NgxSpinnerModule,
    ResizableModule,
    ImageViewerModule,
    DeviceDetectorModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot()
  ],
  providers: [
    CookieService,
    DeviceDetectorService
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
